import { cn } from '@reflex/ui/lib/utils';
import { ConfigBadge } from '@/components/status/ConfigBadge';
import { ACTIVITY_CONFIG } from '@/lib/status-colors';
import type { AgentActivity } from '@/lib/types';
import { AgentHoverPreview } from './AgentHoverPreview';

export function AgentActivityChip({
  activity,
  variant = 'badge',
  agentId,
}: {
  activity: AgentActivity;
  variant?: 'badge' | 'inline';
  /** When set, the badge variant reveals an agent preview on hover. */
  agentId?: string;
}) {
  if (variant === 'inline') {
    const cfg = ACTIVITY_CONFIG[activity];
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
        <span className={cn('h-1.5 w-1.5 rounded-full shrink-0', cfg.dot)} />
        <span className={cfg.sidebar.className}>{cfg.sidebar.text}</span>
      </span>
    );
  }
  const chip = <ConfigBadge config={ACTIVITY_CONFIG} value={activity} />;
  if (!agentId) return chip;
  return <AgentHoverPreview agentId={agentId}>{chip}</AgentHoverPreview>;
}
